module.exports = {
  Range: 'ขอบเขต',
  SorryHavePermissionToInformation: 'ขออภัย! คุณไม่มีสิทธิ์ดูรายละเอียด',
  BusinessInformationSelectionIncorrect: 'เลือกข้อมูลธุรกิจไม่ถูกต้อง',
  DidOnThePreviousDay: 'ยังไม่ได้สำเร็จพิธีการศุลกากรเมื่อวาน',
  DeclaredSameDayAsFlight: 'ทำพิธีการศุลกากรและขึ้นเที่ยวบินในวันเดียวกัน',
  DeclaredOnTheSameDay: 'ทำพิธีการศุลกากรในวันเดียวกัน',
  Other: 'อื่นๆ',
  PleaseTheCustomsDeclarationList: 'กรุณาเลือกรายการศุลกากร',
  LabelPrintingSucceeded: 'พิมพ์ป้ายเรียบร้อยแล้ว',
  ConfirmAudit: 'ยืนยันการตรวจสอบหรือไม่?',
  PleaseTheMasterBillInformation: 'กรุณาเลือกข้อมูลใบตราส่งสินค้าหลัก',
  TheNumberHasBeenInvalidated: 'หมายเลขใบตราส่งสินค้าหลักนี้ถูกยกเลิกแล้ว',
  CancellationSuccessful: 'ยกเลิกสำเร็จ',
  CancellationFail: 'ยกเลิกไม่สำเร็จ',
  ConfirmBillNumberFromBusiness: 'ยืนยันการยกเลิกการผูกพันหมายเลขใบตราส่งสินค้าหลักกับธุรกิจนี้หรือไม่?',
  UnbindingFailed: 'ยกเลิกการผูกพันไม่สำเร็จ',
  UnbindingSuccessful: 'ยกเลิกการผูกพันสำเร็จ',
  MasterBill: 'ใบตราส่งสินค้าหลัก',
  SubBill: 'ใบตราส่งสินค้าย่อย',
  MasterBillStatus: 'สถานะใบตราส่งสินค้าหลัก',
  SubBillStatus: 'สถานะใบตราส่งสินค้าย่อย',
  EnterQueryInformation: 'กรุณากรอกข้อมูลสำหรับค้นหา!',
  ConfirmThis: 'ยืนยันการ',
  ReceiptNumber: 'หมายเลขใบรับคืน',
  AllFlightMustBeLocking: 'ต้องส่งใบตราส่งสินค้าทั้งหมดในเที่ยวบินปัจจุบันก่อนจึงจะล็อกได้!',
  OtherDocuments: 'ไฟล์อื่นๆ',
  CustomsDeclarationDocuments: 'เอกสารศุลกากร',
  PleaseImageYouWantUpload: 'กรุณาเลือกรูปภาพที่จะอัปโหลด',
  InvalidReceiptNumber: 'หมายเลขใบรับคืนไม่ถูกต้อง!',
  InvalidMasterBillNumber: 'หมายเลขใบตราส่งสินค้าหลักไม่ถูกต้อง',
  NoContactTheAirlineImages: 'หมายเลขใบตราส่งสินค้านี้ยังไม่ได้ลงเที่ยวบิน กรุณาติดต่อสายการบินเพื่อลงเที่ยวบินก่อนอัปโหลดรูปภาพ',
  PleaseFileYouWantDownload: 'กรุณาเลือกไฟล์ที่ต้องการดาวน์โหลด',
  UploadWantToUploadImage: 'อัปโหลดสำเร็จ ต้องการอัปโหลดรูปภาพหมายเลขถัดไปหรือไม่?',
  BulkEditingDestinationPortInformation: 'แก้ไขข้อมูลท่าปลายทางแบบกลุ่ม',
  OverseasWarehouseNonAmazonWarehouse: 'คลังสินค้าผ่านแดนนอกประเทศที่ไม่ใช่คลัง Amazon',
  EstimatedArrivalTime: 'เวลาจัดส่งตามที่คาดการณ์',
  ActualArrivalTime: 'เวลาจัดส่งจริง',
  NoDataSelected: 'ไม่ได้เลือกข้อมูล',
  AllAreInNonState: 'ข้อมูลที่เลือกทั้งหมดอยู่ในสถานะไม่ใช่【กำลังดำเนินการ】',
  TheIsNotSelfConsolidation: 'ธุรกิจนี้ไม่ใช่ประเภทการรวมตู้แบบตู้รวมเอง, buyer consol หรือตู้รวมที่มอบหมาย',
  AttachmentTooLarge: 'เนื้อหาของไฟล์แนบมีขนาดใหญ่เกินไป',
  BusinessStatusChangeLog: 'บันทึกการเปลี่ยนแปลงสถานะธุรกิจ',
  DomesticWarehouse: 'คลังสินค้าในประเทศ',
  OverseasWarehouse: 'คลังสินค้าต่างประเทศ',
  LogRecords: 'บันทึกประวัติ',
  GeneralTrade: 'การค้าทั่วไป',
  OperationSuccessful: 'ดำเนินการสำเร็จ',
  PleaseChooseAnAirline: 'กรุณาเลือกสายการบิน!',
  ContainerType: 'ประเภทตู้คอนเทนเนอร์',
  Size: 'รูปแบบตู้คอนเทนเนอร์',
  LockedPleaseContactSupervisorUnlocking: 'ถูกล็อคอยู่ ไม่สามารถพิมพ์ได้ กรุณาติดต่อผู้ดูแลเพื่อปลดล็อค!',
  ProfitAnalysisPrint: 'พิมพ์การวิเคราะห์กำไร',
  DoCopyMasterBillInformation: 'ยืนยันที่จะคัดลอกข้อมูลผู้ส่งและผู้รับในใบสำคัญหรือไม่?',
  DeleteSucceeded: 'ลบสำเร็จ!',
  PleaseFormatOfTheLengthwidthheightquantity: 'กรุณากรอกขนาดในรูปแบบที่ถูกต้อง: ยาว*กว้าง*สูง*จำนวนชิ้น!',
  GenerationFailed: 'สร้างไม่สำเร็จ!',
  CargoCollectionType: 'ประเภทการรับสินค้า',
  Commission: 'มอบหมาย',
  CustomsClearanceMethod: 'วิธีการผ่านศุลกากร',
  ServiceChannel: 'ช่องทางบริการ',
  ExpectedTimeIntoAmazonWarehouse: 'เวลาที่คาดว่าจะเข้าคลัง Amazon',
  ZipCode: 'รหัสไปรษณีย์',
  DestinationDeliveryMethod: 'วิธีการจัดส่งปลายทาง',
  ExpressCompany: 'บริษัทขนส่งด่วน',
  CourierNumber: 'เลขที่พัสดุ',
  POOriginalOrderNumber: 'PO (เลขที่เดิม)',
  EORIBusinessNumber: 'หมายเลข EORI ของบริษัท',
  VATTaxNumber: 'VAT/หมายเลขภาษี',
  VATRegistrationCountry: 'ประเทศที่จด VAT',
  VATRegistrationAddress: 'ที่อยู่ที่จด VAT',
  VATCompanyEnglishName: 'ชื่อบริษัทภาษาอังกฤษสำหรับ VAT',
  EstimatedDeliveryTime: 'เวลาที่คาดว่าจะส่งถึง',
  ActualDeliveryTime: 'เวลาส่งถึงจริง',
  WithBattery: 'มีแบตเตอรี่',
  WithMagnet: 'มีแม่เหล็ก',
  Powder: 'ผง',
  Liquid: 'ของเหลว',
  EstimatedStorageGoodArrivalTime: 'เวลาที่คาดว่าจะเข้าคลัง/สินค้าพร้อม',
  RemoteWarehouse: 'คลังสินค้าห่างไกล',
  AirFreight: 'ค่าขนส่งทางอากาศ',
  FeeType: 'ประเภทค่าใช้จ่าย:',
  EstimatedAmount: 'จำนวนเงินที่ประมาณการ:',
  Equivalent: 'เท่ากับ',
  FreightRateLevel: 'ระดับอัตราค่าขนส่ง:',
  BilledWeight: 'น้ำหนักที่คิดค่าใช้จ่าย:',
  CalculationMethod: 'วิธีการคำนวณ:',
  EstimatedTimeCannotBeEmpty: 'เวลาที่คาดว่าจะเข้าคลัง/สินค้าพร้อมไม่สามารถเว้นว่างได้!',
  DestinationCannotBeEmpty: 'ปลายทางไม่สามารถเว้นว่างได้!',
  DestinationCountryCannotBeEmpty: 'ประเทศปลายทางไม่สามารถเว้นว่างได้!',
  ZipCodeCannotBeEmpty: 'รหัสไปรษณีย์ไม่สามารถเว้นว่างได้!',
  CannotBeEmpty: 'ไม่สามารถเว้นว่างได้!',
  InvalidBillNumberCannotBind: 'เลขที่ใบสำคัญไม่ถูกต้อง ไม่สามารถผูกมัดได้!',
  PleaseTheConsignorUnitFirst: 'กรุณาเลือกหน่วยงานที่มอบหมายก่อน',
  TheExpensesCanNotMode: 'ใบสำคัญปัจจุบันมีค่าใช้จ่ายที่แบ่งปัน ไม่สามารถเปลี่ยนโหมดการทำงานได้!',
  DoRefreshTheMAWBInformation: 'ต้องการรีเฟรชข้อมูลที่เกี่ยวข้องกับ MAWB หรือไม่?',
  CourierCompany: 'บริษัทขนส่งด่วน',
  ForeignWarehouse: 'คลังสินค้าต่างประเทศ',
  CustomsDeclarationMethod: 'วิธีการสำแดงศุลกากร',
  TheSharedExpensesCanSeparate: 'ใบสำคัญปัจจุบันมีค่าใช้จ่ายที่แบ่งปัน ไม่สามารถแยกได้!',
  RemoveTicketSuccessfully: 'ลบใบสำคัญสำเร็จ!',
  AttachmentDescription: 'คำอธิบายไฟล์แนบ:',
  AirlineCannotBeEmpty: 'สายการบินไม่สามารถเว้นว่างได้',
  AddNew: 'เพิ่มใหม่',
  NoItemDetailsSelected: 'ยังไม่ได้เลือกรายละเอียดสินค้า!',
  SellingPriceCalculationCompleted: 'คำนวณราคาขายเสร็จสิ้น',
  PleaseSelectWarehouseEntryData: 'กรุณาเลือกข้อมูลการนำเข้าคลัง!',
  DeletedSuccessfully: 'ลบสำเร็จ!',
  PleaseAPieceOfData: 'กรุณาเลือกข้อมูลหนึ่งรายการ!',
  CustomsClearanceTracking: 'ติดตามการสำแดงศุลกากร',
  CustomsClearanceQuantity: 'จำนวนชิ้นสำแดงศุลกากร',
  CustomsClearanceWeight: 'น้ำหนักสำแดงศุลกากร',
  CustomsClearanceDate: 'วันที่สำแดงศุลกากร',
  CustomsClearanceInformation: 'ข้อมูลการสำแดงศุลกากร',
  MultipleCustomsDeclarations: 'หลายใบสำแดงศุลกากร',
  WhetherApplyForCommercialInspection: 'มีการตรวจสอบสินค้าหรือไม่',
  WhetherToCheck: 'มีการตรวจสอบหรือไม่',
  PleaseSelectCustomsClearanceInformation: 'กรุณาเลือกข้อมูลการสำแดงศุลกากร',
  TheBeEqualToBusiness: 'ผลรวมน้ำหนักและจำนวนชิ้นสำแดงศุลกากรต้องเท่ากับของจริงในธุรกิจ',
  NextLegEntry: 'บันทึกเที่ยวบินต่อเนื่อง',
  ActualFlight: 'เที่ยวบินจริง:',
  NextLegInformation: 'ข้อมูลเที่ยวบินต่อเนื่อง:',
  ActualFlightCannotBeEmpty: 'เที่ยวบินจริงไม่สามารถเว้นว่างได้',
  ActualDepartureDate: 'วันที่ออกเที่ยวบินจริง',
  NextInformationCannotBeEmpty: 'ข้อมูลเที่ยวบินต่อเนื่องไม่สามารถเว้นว่างได้',
  BatchModificationOfReportStatus: 'แก้ไขสถานะรายงานเป็นชุด',
  CustomsClearanceStatus: 'สถานะการสำแดงศุลกากร:',
  PleaseSelectCustomsClearanceStatus: 'กรุณาเลือกสถานะการสำแดงศุลกากร',
  SelectAirPort: 'เลือกท่าอากาศยาน',
  PleaseSelectAPort: 'กรุณาเลือกท่าเรือ!',
  FlightSelection: 'เลือกเที่ยวบิน',
  Monday: 'จันทร์',
  Tuesday: 'อังคาร',
  Wednesday: 'พุธ',
  Thursday: 'พฤหัสบดี',
  Friday: 'ศุกร์',
  Saturday: 'เสาร์',
  Sunday: 'อาทิตย์',
  FlightSchedule: 'ตารางบิน',
  Weekly: 'ทุกสัปดาห์',
  PleaseSelectAFlight: 'กรุณาเลือกเที่ยวบินหนึ่งเที่ยว',
  PleaseEnterACode: 'กรุณากรอกรหัส!',
  CodeExistsPleaseReEnter: 'รหัสนี้มีอยู่แล้ว กรุณากรอกใหม่!',
  PleaseEnterAName: 'กรุณากรอกชื่อ!',
  PleaseAddARegionalPort: 'กรุณาเพิ่มท่าเรือเขต!',
  AreYouWantToDelete: 'ยืนยันที่จะลบหรือไม่?',
  PleaseTheDepartureRegionCode: 'กรุณากรอกรหัสเขตต้นทาง!',
  PleaseTheDestinationRegionCode: 'กรุณากรอกรหัสเขตปลายทาง!',
  DepartureRegionCodeCannotSame: 'รหัสเขตต้นทางและปลายทางต้องไม่เหมือนกัน!',
  WeeklySchedule: 'ตารางเดินเรือ',
  PleaseEffectiveDateStartTime: 'กรุณาเลือกเวลาเริ่มต้นมีผล!',
  PleaseSelectTheSchedule: 'กรุณาเลือกรอบเที่ยวบิน!',
  PleaseEnterTheTransshipmentPort: 'กรุณากรอกท่าเรือขนส่ง',
  AreWantToDeleteRoute: 'ยืนยันที่จะลบเส้นทางหรือไม่?',
  GenerateFlight: 'สร้างเที่ยวบิน',
  PleaseEnterAFlightNumber: 'กรุณากรอกหมายเลขเที่ยวบิน!',
  PleaseEnterAnAirline: 'กรุณากรอกสายการบิน!',
  PleaseEnterTheDeparturePort: 'กรุณากรอกท่าเรือต้นทาง!',
  PleaseEnterTheDestinationPort: 'กรุณากรอกท่าเรือปลายทาง!',
  PleaseDepartureTimeForWeek: 'กรุณากรอกสัปดาห์',
  AreWantToDeleteFlight: 'ยืนยันที่จะลบเที่ยวบินหรือไม่?',
  TheWantToDeleteRegenerate: 'สร้างเที่ยวบินแล้ว ต้องการลบข้อมูลเดิมและสร้างใหม่หรือไม่?',
  GenerationSuccessful: 'สร้างสำเร็จ',
  AtBookingNatureAirportEntered: 'ต้องกรอกอย่างน้อยหนึ่งรายการจาก: เส้นทางบิน, สายการบิน, ประเภทการจอง, ท่าอากาศยาน, การขาย!',
  ResponsibilitiesAssignedNoDeletionAllowed: 'มีการมอบหมายหน้าที่แล้ว ไม่สามารถลบได้!',
  AreToDeleteThisRecord: 'ยืนยันที่จะลบรายการนี้หรือไม่?',
  TheTheAirlineIsModify: 'รหัสสามตัวอักษรสายการบินไม่ถูกต้อง กรุณาแก้ไข!',
  PleaseSelectAnAirline: 'กรุณาเลือกสายการบิน!',
  PleaseSelectTheExpirationDate: 'กรุณาเลือกวันที่หมดอายุ!',
  PleaseStartingMasterBillNumber: 'กรุณากรอกหมายเลขเอกสารหลักเริ่มต้น!',
  TheLegalThereIsAirline: 'หมายเลขเริ่มต้นไม่ถูกต้อง ไม่มีสายการบินที่ตรงกัน!',
  TheNumberIsNotLegal: 'หมายเลขเอกสารหลักไม่ถูกต้อง!',
  PleaseTheDateOfPossession: 'กรุณาเลือกวันที่รับ!',
  TheMasterBillMayExist: 'หมายเลขเอกสารหลักในช่วงนี้อาจมีอยู่แล้ว!',
  ConfirmDeleteTheMasterBill: 'ยืนยันที่จะลบเอกสารหลัก?',
  CancelSubmission: 'ยกเลิกการส่ง',
  SaveSuccessfully: 'บันทึกสำเร็จ!',
  SaveSuccess: 'บันทึกสำเร็จ',
  PleaseTheWarehouseEntryNumber: 'กรุณากรอกหมายเลขเข้าโกดัง!',
  PleaseWeightOfTheSeal: 'กรุณาเลือกน้ำหนักผนึก!',
  PleaseEnterTheWarehouseName: 'กรุณากรอกชื่อโกดัง!',
  ReviewSucceeded: 'ตรวจสอบสำเร็จ!',
  LockedContactAHigherUnlock: 'ถูกล็อค ไม่สามารถพิมพ์ได้ กรุณาติดต่อผู้ดูแลปลดล็อค!',
  PleasePortOfDepartureDestination: 'กรุณากรอกท่าเรือต้นทางหรือปลายทาง!',
  SaveFileFormatIsIncorrect: 'บันทึกไม่สำเร็จ รูปแบบไฟล์ Excel ไม่ถูกต้อง!',
  SuccessfullyImported: 'นำเข้าสำเร็จ',
  PiecesOfData: 'รายการข้อมูล!',
  SaveFailed: 'บันทึกไม่สำเร็จ!',
  PleaseThePortOfDeparture: 'กรุณากรอกท่าเรือต้นทาง!',
  CompleteOperationRequirements: 'ดำเนินการตามคำขอเสร็จสิ้น',
  PleaseSelectTheCompletionTime: 'กรุณาเลือกเวลาที่เสร็จสิ้น',
  CurrentlySelected: '(ที่เลือกอยู่)',
  CurrentPage: '(หน้าปัจจุบัน)',
  CompletionStatus: 'สถานะการเสร็จสิ้น',
  Completed: 'เสร็จสิ้นแล้ว',
  Uncompleted: 'ยังไม่เสร็จสิ้น',
  OperationRequirementDescription: 'คำอธิบายคำขอการดำเนินการ',
  CurrentSelectionIncludesCompletedStatus: 'การเลือกปัจจุบันรวมถึงสถานะที่เสร็จสิ้นแล้ว',
  OperationRequirementTracking: 'ติดตามคำขอการดำเนินการ',
  ConfirmCancellation0: 'ยืนยันที่จะยกเลิกหมายเลข [{0}] หรือไม่?',
  DeDepartureTime: 'เวลาออกบิน',
  AERequiredChecksum: 'ต้องกรอกหมายเลขเริ่มต้นของใบนำหรือเพิ่มแบบกลุ่มอย่างใดอย่างหนึ่ง',
  FlightInformation: 'ข้อมูลเที่ยวบิน',
  TrackingDetails: 'รายละเอียดการติดตามสินค้า',
  StartingStation: 'สถานีเริ่มต้น',
  DestinationStation: 'สถานีปลายทาง',
  FlightNumber: 'หมายเลขเที่ยวบิน',
  DepartureTime: 'เวลาออกเดินทาง',
  ArrivalTime: 'เวลาถึง',
  Pieces: 'จำนวนชิ้น',
  Weight: 'น้ำหนัก',
  Time: 'เวลา',
  Status: 'สถานะ',
  Airport: 'สนามบิน',
  Unknown: 'ไม่ทราบ',
  BKD: 'จองพื้นที่บรรทุก',
  RCS: 'นำเข้าคลัง',
  MAN: 'การจัดวางสินค้า',
  DEP: 'ขึ้นบิน',
  ARR: 'มาถึง',
  AWD: 'รับเอกสาร',
  RCF: 'ขนถ่ายสินค้า',
  NFD: 'แจ้งเตือนสินค้ามาถึง',
  DLV: 'รับสินค้า',
  TAR: 'มาถึงจุดเปลี่ยนถ่าย',
  TDE: 'ขึ้นบินต่อจากจุดเปลี่ยนถ่าย',
  TRF: 'ขนถ่ายสินค้าที่จุดเปลี่ยนถ่าย',
  RWB: 'รับเอกสาร',
  CUS: 'ดำเนินการศุลกากร',
  AeMawbChargeWeight: 'น้ำหนักคิดค่าบริการการทำเอกสารขนส่งทางอากาศ',
  AeBookingChargeWeight: 'น้ำหนักคิดค่าบริการการจองพื้นที่ขนส่งทางอากาศ',
  MawbChargeWeight: 'น้ำหนักคิดค่าบริการการทำเอกสาร',
  BookingChargeWeight: 'น้ำหนักคิดค่าบริการการจองพื้นที่',
  ImportBoardInstallInfo: 'นำเข้าข้อมูลการบรรจุแผง',
  PleaseImportCorrectTemplate: 'กรุณานำเข้าข้อมูลจากแบบฟอร์มที่ถูกต้อง',
  ClickDownloadTemplate: 'สามารถคลิกเพื่อดาวน์โหลดแบบฟอร์ม',
  AsyncUploadLogView: 'การดำเนินการนี้เป็นแบบอะซิงโครนัส สามารถตรวจสอบผลการนำเข้าได้ที่ "ที่เก็บไฟล์ -> บันทึกการอัปโหลด"',
  ServiceInformation: 'ข้อมูลบริการ',
  ControlDisplayConfiguration: 'การตั้งค่าการแสดงผลควบคุม',
  WovenFabricorder: 'ผ้าทอ (คำสั่งซื้อ)',
  BookingForCargobooking: 'การจองสำหรับสินค้า (การจอง)',
  ItemMaoTiForwardWarehouseActual: 'รายการ毛体 (คลังสินค้าล่วงหน้า (จริง))',
  ItemMaoTiOrderProcessing: '毛体รายการ (การจัดการคำสั่งซื้อ)'
}
